import React from 'react';
import type { CampaignCreationStep } from '../../types/campaign';

interface CampaignStepperProps {
  currentStep: CampaignCreationStep;
}

const steps = [
  { id: 'campaign', label: 'Campaign Details', number: 1 },
  { id: 'markets', label: 'Market Strategy', number: 2 },
  { id: 'launch', label: 'Launch', number: 3 },
];

export default function CampaignStepper({ currentStep }: CampaignStepperProps) {
  const getStepIndex = (step: CampaignCreationStep): number => {
    if (step === 'campaign') return 0;
    if (step === 'markets') return 1;
    return -1;
  };

  const currentIndex = getStepIndex(currentStep);

  return (
    <div className="flex items-center justify-center py-4 sm:py-6 px-2">
      {steps.map((step, index) => {
        const isActive = index <= currentIndex;

        return (
          <React.Fragment key={step.id}>
            <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3">
              <div
                className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 flex items-center justify-center text-xs sm:text-sm font-medium transition-colors ${
                  isActive
                    ? 'border-accent text-accent'
                    : 'border-gray-600 text-gray-500'
                }`}
              >
                {step.number}
              </div>
              <span
                className={`text-xs sm:text-sm font-medium transition-colors text-center leading-tight ${
                  isActive ? 'text-accent' : 'text-gray-500'
                }`}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`w-6 sm:w-12 lg:w-16 h-0.5 mx-1 sm:mx-2 lg:mx-4 transition-colors flex-shrink-0 ${
                  index < currentIndex ? 'bg-accent' : 'bg-gray-600'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
